import {CanMatchFn} from '@angular/router';

const allowedFixtureStates = new Set([
  'completed',
  'partial',
  'broken-auth',
  'missing-scope',
  'missing-mapping',
  'unknown-permissions',
  'subunit-config-empty',
  'subunit-loading',
  'subunit-empty',
  'subunit-summary',
  'subunit-error',
  'dnb-usage',
  'company-capture',
  'company-search',
]);

const allowedFixturePaths = new Set([
  '/enrich/setup',
  '/enrich/auth',
  '/enrich/settings',
  '/enrich/mapping',
  '/enrich/companies',
]);

export function isEnrichVisualFixtureUrl(href: string): boolean {
  const url = new URL(href);
  const isLocalHost = ['localhost', '127.0.0.1', '[::1]', '::1'].includes(url.hostname);
  const fixtureState = url.searchParams.get('enrichVisualFixture') || '';

  return isLocalHost && allowedFixturePaths.has(url.pathname) && allowedFixtureStates.has(fixtureState);
}

export const enrichVisualFixtureCanMatch: CanMatchFn = () => {
  if (typeof window === 'undefined' || !window.location) return false;

  return isEnrichVisualFixtureUrl(window.location.href);
};
